import $ from 'jquery';
import * as CONST from '../utils/constants';

class EventDetails {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.card-summary a.btn.primary-btn[href="#register"]').click((event) => {
            const dest = $(event.target).attr('href');
            $('html, body').animate({
                scrollTop: $(dest).offset().top - 150
            }, 1000);
        });
    }
}

export default EventDetails;